import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {WorkoutRepository} from '../ports/workout.repository';

export class GetActiveWorkout implements UseCase<[], Workout | null> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(): Promise<Result<Workout | null, WorkoutError>> {
    return this.repository.getActiveWorkout();
  }
}
